import { render, staticRenderFns } from "./NsTopnavLinkList.vue?vue&type=template&id=329dd089&scoped=true&"
import script from "./NsTopnavLinkList.vue?vue&type=script&lang=js&"
export * from "./NsTopnavLinkList.vue?vue&type=script&lang=js&"
import style0 from "./NsTopnavLinkList.vue?vue&type=style&index=0&id=329dd089&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../packages/aem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329dd089",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('329dd089')) {
      api.createRecord('329dd089', component.options)
    } else {
      api.reload('329dd089', component.options)
    }
    module.hot.accept("./NsTopnavLinkList.vue?vue&type=template&id=329dd089&scoped=true&", function () {
      api.rerender('329dd089', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@nuskin/app-components/components/NsTopnavLinkList.vue"
export default component.exports